import React, { useState, useEffect } from "react";
import {
  MdSearch,
  MdShoppingCart,
  MdInfoOutline,
  MdStore,
  MdList,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdFilterList,
  MdHistory,
  MdExitToApp,
  MdAccountCircle,
  MdLogin,
  MdClose,
  MdHome,
} from "react-icons/md";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getProducts, getServices } from "../../services/inventory.service";
import { getStorefrontThemePreset, resolveThemeId } from "./themeTemplates/storefrontThemePresets";
import { ThemeLayoutContent, getLayoutType, isDarkTheme } from "./themeTemplates/ThemeLayouts";
import { THEME_IMAGES } from "./themeTemplates/ThemeLayoutHelpers";
import { getBusinessTypeDefaultTheme, shouldUseBusinessDefaultTheme } from "./themeTemplates/businessThemeDefaults";
import { AccountLoginDialog } from "./accountLogin";
import { getBusiness } from "../../services/auth.service";
import { toast } from "react-toastify";
import {
  createCustomer,
} from "../../services/customer.service";
import { AWS_URL } from "../../services/http.service";
import { storeSettingsService } from "../../services/storeSettings.service";
import ImageTen from "../../assets/pexels-padrinan.jpg";
import { useSelector, useDispatch } from "react-redux";
import LanguageChangerStoreFront from "../../components/LanguageChangerStoreFront.jsx";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import { getLandingPagePath, getStorefrontPath } from "./storefrontPaths";
import {
  trackPageView,
  trackAddToCart,
} from "../../components/common/utlity/tracking.js";
import { FaHeart } from "react-icons/fa";
import { LogoLoading } from "../../components/common/utlity/utility.js";
import { getUserCart } from "../../services/cart.service";
import { fetchWishlist, clearWishlistState } from '../../store/actions/action.js';

// Toast Notification Component - RESPONSIVE
function Toast({ message, type = "success", onClose }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const bgColor = type === "success" ? "bg-green-500" : "bg-red-500";

  return (
    <div className='fixed top-2 sm:top-4 right-2 sm:right-4 z-[1000] animate-slide-in max-w-[90vw] sm:max-w-sm'>
      <div
        className={`${bgColor} text-white px-3 sm:px-4 md:px-6 py-2.5 sm:py-3 md:py-4 rounded-lg shadow-lg flex items-center justify-between min-w-[250px] sm:min-w-[300px] md:min-w-[320px]`}
        style={{
          boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
          position: 'relative',
          zIndex: 1000
        }}
      >
        <span className="text-xs sm:text-sm md:text-base">{message}</span>
        <button onClick={onClose} className='text-white ml-2 sm:ml-3 md:ml-4 flex-shrink-0'>
          <MdClose className="text-sm sm:text-base" />
        </button>
      </div>
    </div>
  );
}

// User Profile Menu Component - RESPONSIVE
function UserProfileMenu({
  userProfile,
  onLogout,
  onViewOrders,
  onViewProfile,
  onLogin,
  onBackToLanding,
  theme,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const isDark = isDarkTheme(theme);
  const hoverBg = isDark ? 'hover:bg-gray-700' : 'hover:bg-gray-50';
  const borderColor = isDark ? 'border-gray-700' : 'border-gray-100';
  const textColor = theme?.textColor || (isDark ? '#e5e7eb' : '#1f2937');
  const subTextColor = (theme?.textColor || (isDark ? '#9ca3af' : '#6b7280')) + "80";
const location = useLocation();
  const themeId = resolveThemeId(theme || {});
  const isLunar = themeId === 'lunar';

  console.log("theme", theme.buttonColor)
  return (
    <div className='relative'>
      <button
        className='flex items-center gap-1.5 sm:gap-2 px-2 sm:px-3 py-1.5 rounded-lg hover:opacity-90 transition'
        onClick={() => setIsOpen(!isOpen)}
        style={{
          backgroundColor: isLunar ? "#000000" : (theme?.buttonColor || "#4f46e5"),
          border: isLunar ? "1px solid rgba(255, 255, 255, 0.15)" : "none",
          color: "#ffffff",
          borderRadius:
            theme?.buttonStyle === "pill"
              ? "9999px"
              : theme?.buttonStyle === "rounded"
                ? "8px"
                : "4px",
          fontFamily: theme?.fontFamily || "Inter",
        }}
      >
        <div
          className='w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-white flex items-center justify-center text-xs sm:text-sm font-medium shadow-sm'
          style={{ color: isLunar ? "#000000" : (theme?.buttonColor || "#4f46e5") }}
        >
          {userProfile?.name ? userProfile.name.charAt(0).toUpperCase() : "G"}
        </div>
        <span className='hidden sm:inline text-xs sm:text-sm font-medium truncate max-w-[60px] sm:max-w-[100px]'>
          {userProfile?.name || t("ONLINE_STORE.GUEST")}
        </span>
        <MdKeyboardArrowDown
          className={`transition-transform text-sm sm:text-base ${isOpen ? "rotate-180" : ""}`}
        />
      </button>

      {isOpen && (
        <div
          className={`absolute right-0 mt-2 w-[280px] sm:w-64 rounded-lg shadow-lg py-2 z-50 border ${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}
          style={{
            fontFamily: theme?.fontFamily || "Inter",
            backgroundColor: isDark ? undefined : theme?.backgroundColor
          }}
        >
          <div className={`px-4 py-2 border-b ${borderColor}`}>
            <p
              className='text-sm font-medium'
              style={{ color: theme?.headingColor || (isDark ? '#fff' : '#1f2937') }}
            >
              {userProfile?.name ||
                t("ONLINE_STORE.GUEST_USER") ||
                t("ONLINE_STORE.GUEST")}
            </p>
            <p
              className='text-xs'
              style={{ color: subTextColor }}
            >
              {userProfile?.customer_mobile || t("ONLINE_STORE.NO_PHONE_NO")}
            </p>
          </div>

          <button
            className={`block px-4 py-2.5 sm:py-3 text-sm ${hoverBg} w-full text-left flex items-center gap-2 sm:gap-3 transition-colors`}
            onClick={() => {
              onViewProfile();
              setIsOpen(false);
            }}
            style={{ color: textColor }}
          >
            <MdAccountCircle
              className='text-lg flex-shrink-0'
              style={{ color: theme?.primaryColor || "#4f46e5" }}
            />
            <div>
              <div className='font-medium text-xs sm:text-sm'>
                {t("ONLINE_STORE.PROFILE_DETAILS")}
              </div>
              <div
                className='text-[10px] sm:text-xs'
                style={{ color: subTextColor }}
              >
                {t("ONLINE_STORE.PROFILE_SUBTITLE")}
              </div>
            </div>
          </button>

          <button
            className={`block px-4 py-2.5 sm:py-3 text-sm ${hoverBg} w-full text-left flex items-center gap-2 sm:gap-3 transition-colors`}
            onClick={() => {
              onViewOrders();
              setIsOpen(false);
            }}
            style={{ color: textColor }}
          >
            <MdHistory
              className='text-lg flex-shrink-0'
              style={{ color: theme?.secondaryColor || "#10b981" }}
            />
            <div>
              <div className='font-medium text-xs sm:text-sm'>
                {t("ONLINE_STORE.ORDER_HISTORY")}
              </div>
              <div
                className='text-[10px] sm:text-xs'
                style={{ color: subTextColor }}
              >
                {t("ONLINE_STORE.ORDER_SUBTITLE")}
              </div>
            </div>
          </button>

          <button
            className={`block px-4 py-2.5 sm:py-3 text-sm ${hoverBg} w-full text-left flex items-center gap-2 sm:gap-3 transition-colors`}
            onClick={() => {
              onBackToLanding();
              setIsOpen(false);
            }}
            style={{ color: textColor }}
          >
            <MdHome
              className='text-lg flex-shrink-0'
              style={{ color: theme?.primaryColor || "#4f46e5" }}
            />
            <div>
              <div className='font-medium text-xs sm:text-sm'>
                {t("STORE.LANDING") || "Landing Page"}
              </div>
              <div
                className='text-[10px] sm:text-xs'
                style={{ color: subTextColor }}
              >
                {t("STORE.BACK_TO_LANDING_PAGE") || "Go to landing page"}
              </div>
            </div>
          </button>

          <div className={`px-4 py-2.5 sm:py-3 text-sm ${hoverBg} w-full text-left flex items-center gap-2 sm:gap-3 transition-colors border-t ${borderColor}`}>
            <LanguageChangerStoreFront displayType="dropdown" />
          </div>

          {!userProfile && (
            <button
              className={`block px-4 py-2.5 sm:py-3 text-sm ${hoverBg} w-full text-left flex items-center gap-2 sm:gap-3 transition-colors border-t ${borderColor}`}
              onClick={() => {
                onLogin();
                setIsOpen(false);
              }}
              style={{ color: theme?.primaryColor || "#4f46e5" }}
            >
              <MdLogin className='text-lg flex-shrink-0' />
              <div>
                <div className='font-medium text-xs sm:text-sm'>{t("ONLINE_STORE.SIGN_IN")}</div>
                <div
                  className='text-[10px] sm:text-xs'
                  style={{ color: theme?.primaryColor + "80" || "#4f46e5" }}
                >
                  {t("ONLINE_STORE.ACCESS_YOUR_ACCOUNT")}
                </div>
              </div>
            </button>
          )}
          {userProfile && (
            <button
              className={`block px-4 py-2.5 sm:py-3 text-sm ${hoverBg} w-full text-left flex items-center gap-2 sm:gap-3 transition-colors border-t ${borderColor}`}
              onClick={() => {
                onLogout();
                setIsOpen(false);
              }}
              style={{ color: textColor }}
            >
              <MdExitToApp className='text-lg flex-shrink-0 text-red-500' />
              <div>
                <div className='font-medium text-xs sm:text-sm'>
                  {userProfile?.customer_mobile
                    ? t("ONLINE_STORE.LOGOUT")
                    : t("ONLINE_STORE.SWITCH_TO_ACCOUNT")}
                </div>
                <div
                  className='text-[10px] sm:text-xs'
                  style={{ color: subTextColor }}
                >
                  {userProfile?.customer_mobile
                    ? t("ONLINE_STORE.SIGN_OUT_OF_YOUR_ACCOUNT")
                    : t("ONLINE_STORE.CREATE_OR_SIGNIN_ACCOUNT")}
                </div>
              </div>
            </button>
          )}
        </div>
      )}
    </div>
  );
}

// FilterPanel Component - RESPONSIVE
function FilterPanel({ isOpen, onClose, allProducts, onFilter, theme }) {
  const [priceRange, setPriceRange] = useState([0, 10000]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSubcategories, setSelectedSubcategories] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [sortBy, setSortBy] = useState("name");
  const [availability, setAvailability] = useState("all");
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const [isSubcategoryOpen, setIsSubcategoryOpen] = useState(false);
  const [isBrandOpen, setIsBrandOpen] = useState(false);
  const [isPriceOpen, setIsPriceOpen] = useState(false);
  const [isAvailabilityOpen, setIsAvailabilityOpen] = useState(false);
  const [isSortOpen, setIsSortOpen] = useState(false);
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [categorySearch, setCategorySearch] = useState("");
  const [brandSearch, setBrandSearch] = useState("");
  const isDark = isDarkTheme(theme);
  const sectionBg = isDark ? 'bg-gray-800/50' : 'bg-white';
  const labelColor = theme?.textColor || (isDark ? '#e5e7eb' : '#1f2937');
  const headingColor = theme?.headingColor || (isDark ? '#f9fafb' : '#111827');
  const mutedColor = isDark ? '#9ca3af' : '#6b7280';
  const hoverBgClass = isDark ? 'hover:bg-gray-700' : 'hover:bg-gray-100';
  const inactiveBtnBg = isDark ? '#374151' : 'white';
const location = useLocation();
  const categories = [
    ...new Set(
      allProducts.map((product) => product.productCategory).filter(Boolean),
    ),
  ].sort();

  const subcategories = [
    ...new Set(
      allProducts.map((product) => product.productSubCategory).filter(Boolean),
    ),
  ].sort();

  const brands = [
    ...new Set(allProducts.map((product) => product.brandName).filter(Boolean)),
  ].sort();

  const categorySubcategoryMap = allProducts.reduce((acc, product) => {
    if (product.productCategory && product.productSubCategory) {
      if (!acc[product.productCategory]) {
        acc[product.productCategory] = new Set();
      }
      acc[product.productCategory].add(product.productSubCategory);
    }
    return acc;
  }, {});

  const maxPrice = Math.max(
    ...allProducts.map((p) => Number(p.salePrice) || 0),
    10000,
  );

  const filteredCategories = categories.filter((category) =>
    category.toLowerCase().includes(categorySearch.toLowerCase()),
  );

  const filteredBrands = brands.filter((brand) =>
    brand.toLowerCase().includes(brandSearch.toLowerCase()),
  );

  const getAvailableSubcategories = () => {
    if (selectedCategories.length === 0) {
      return subcategories;
    }

    const filteredSet = new Set();
    selectedCategories.forEach((category) => {
      if (categorySubcategoryMap[category]) {
        categorySubcategoryMap[category].forEach((subcat) =>
          filteredSet.add(subcat),
        );
      }
    });

    return Array.from(filteredSet).sort();
  };

  const availableSubcategories = getAvailableSubcategories();

  const applyFilters = () => {
    let filtered = allProducts.filter((product) => {
      const price = Number(product.salePrice) || 0;
      const inPriceRange = price >= priceRange[0] && price <= priceRange[1];
      const inCategory =
        selectedCategories.length === 0 ||
        selectedCategories.includes(product.productCategory);
      const inSubcategory =
        selectedSubcategories.length === 0 ||
        selectedSubcategories.includes(product.productSubCategory);
      const inBrand =
        selectedBrands.length === 0 ||
        selectedBrands.includes(product.brandName);
      const isAvailable =
        availability === "all" ||
        (availability === "in-stock" && product.quantity > 0) ||
        (availability === "out-of-stock" && product.quantity <= 0);

      return (
        inPriceRange && inCategory && inSubcategory && inBrand && isAvailable
      );
    });

    const sortedProducts = [...filtered].sort((a, b) => {
      const priceA = Number(a.salePrice) || 0;
      const priceB = Number(b.salePrice) || 0;

      switch (sortBy) {
        case "name":
          return a.productName.localeCompare(b.productName);
        case "price-low":
          return priceA - priceB;
        case "price-high":
          return priceB - priceA;
        case "quantity-high":
          return (b.quantity || 0) - (a.quantity || 0);
        case "recent":
          return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
        case "discount-high":
          const discountA =
            ((Number(a.mrp || a.salePrice) - Number(a.salePrice)) /
              Number(a.mrp || a.salePrice)) *
              100 || 0;
          const discountB =
            ((Number(b.mrp || b.salePrice) - Number(b.salePrice)) /
              Number(b.mrp || b.salePrice)) *
              100 || 0;
          return discountB - discountA;
        default:
          return 0;
      }
    });

    onFilter(sortedProducts);
    onClose();
  };

  const clearFilters = () => {
    setPriceRange([0, maxPrice]);
    setSelectedCategories([]);
    setSelectedSubcategories([]);
    setSelectedBrands([]);
    setSortBy("name");
    setAvailability("all");
    setExpandedCategory(null);
    setCategorySearch("");
    setBrandSearch("");
    onFilter(allProducts);
  };

  const toggleCategory = (category) => {
    setSelectedCategories((prev) =>
      prev.includes(category)
        ? prev.filter((c) => c !== category)
        : [...prev, category],
    );
  };

  const toggleSubcategory = (subcategory) => {
    setSelectedSubcategories((prev) =>
      prev.includes(subcategory)
        ? prev.filter((s) => s !== subcategory)
        : [...prev, subcategory],
    );
  };

  const toggleBrand = (brand) => {
    setSelectedBrands((prev) =>
      prev.includes(brand) ? prev.filter((b) => b !== brand) : [...prev, brand],
    );
  };

  const selectAllCategories = () => {
    setSelectedCategories(categories);
  };

  const clearAllCategories = () => {
    setSelectedCategories([]);
    setSelectedSubcategories([]);
  };

  const selectAllSubcategories = () => {
    setSelectedSubcategories(availableSubcategories);
  };

  const clearAllSubcategories = () => {
    setSelectedSubcategories([]);
  };

  const selectAllBrands = () => {
    setSelectedBrands(brands);
  };

  const clearAllBrands = () => {
    setSelectedBrands([]);
  };

  if (!isOpen) return null;

  return (
    <div className='fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex justify-end animate-fade-in'>
      <div
        className={`w-full max-w-[95vw] sm:max-w-sm h-full overflow-y-auto shadow-xl animate-slide-in flex flex-col ${isDark ? 'bg-gray-900' : 'bg-white'}`}
        style={{
          fontFamily: theme?.fontFamily || "Inter",
          backgroundColor: theme?.backgroundColor,
        }}
      >
        {/* Header */}
        <div className={`sticky top-0 z-20 p-3 sm:p-4 border-b flex justify-between items-center backdrop-blur-sm ${isDark ? 'bg-gray-900/95 border-gray-800' : 'bg-white/95 border-gray-100'}`}
             style={{ backgroundColor: theme?.backgroundColor ? `${theme.backgroundColor}f2` : undefined }}>
          <div className='flex items-center gap-2'>
            <div
              className='p-1.5 rounded-md'
              style={{
                backgroundColor: theme?.primaryColor + "10" || "#f0f2ff",
              }}
            >
              <MdFilterList
                className='text-base sm:text-lg'
                style={{ color: theme?.primaryColor || "#4f46e5" }}
              />
            </div>
            <div>
              <h2
                className='text-sm sm:text-base font-bold'
                style={{ color: headingColor }}
              >
                {t("STORE.FILTER_PRODUCTS")}
              </h2>
              <p
                className='text-[10px] sm:text-xs mt-0.5'
                style={{ color: mutedColor }}
              >
                {allProducts.length} {t("STORE.PRODUCTS")}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className={`p-1.5 rounded transition-colors ${isDark ? 'hover:bg-gray-800' : 'hover:bg-gray-100'}`}
            style={{ color: theme?.textColor || (isDark ? '#fff' : '#1f2937') }}
            aria-label='Close filter panel'
          >
            <MdClose size={18} className="sm:text-xl" />
          </button>
        </div>

        {/* Filter Content */}
        <div className='flex-1 overflow-y-auto p-3 sm:p-4 space-y-2 sm:space-y-3'>
          {/* Sort Section */}
          <div className={`${isDark ? 'bg-gray-800/50' : 'bg-white'} rounded-lg`}>
            <button
              onClick={() => setIsSortOpen(!isSortOpen)}
              className='w-full p-2.5 sm:p-3 flex justify-between items-center rounded-lg transition-colors'
            >
              <div className='flex items-center gap-2'>
                <div
                  className='p-1 rounded'
                  style={{
                    backgroundColor: theme?.primaryColor + "10" || "#f0f2ff",
                  }}
                >
                  <MdFilterList
                    className='text-xs sm:text-sm'
                    style={{ color: theme?.primaryColor || "#4f46e5" }}
                  />
                </div>
                <span
                  className='text-xs sm:text-sm font-medium'
                  style={{ color: headingColor }}
                >
                  {t("STORE.SORT_BY")}
                </span>
              </div>
              {isSortOpen ? (
                <MdKeyboardArrowUp className='text-gray-500 text-sm' />
              ) : (
                <MdKeyboardArrowDown className='text-gray-500 text-sm' />
              )}
            </button>

            {isSortOpen && (
              <div className='px-2 sm:px-3 pb-2 sm:pb-3 pt-1 animate-fade-in'>
                <div className='grid grid-cols-2 gap-1.5 sm:gap-2'>
                  {[
                    { value: "name", label: t("STORE.NAME"), icon: "A" },
                    {
                      value: "price-low",
                      label: t("STORE.PRICE_LOW"),
                      icon: "₹↓",
                    },
                    {
                      value: "price-high",
                      label: t("STORE.PRICE_HIGH"),
                      icon: "₹↑",
                    },
                    {
                      value: "discount-high",
                      label: t("STORE.BEST_DISCOUNT"),
                      icon: "%↑",
                    },
                    {
                      value: "quantity-high",
                      label: t("STORE.MOST_STOCK"),
                      icon: "📦",
                    },
                    { value: "recent", label: t("STORE.NEWEST"), icon: "🆕" },
                  ].map((option) => (
                    <button
                      key={option.value}
                      onClick={() => setSortBy(option.value)}
                      className={`py-1.5 sm:py-2 px-1.5 sm:px-2 rounded text-[10px] sm:text-xs font-medium transition-all duration-150 flex items-center gap-1 sm:gap-1.5 ${
                        sortBy === option.value
                          ? "ring-1 ring-offset-1 shadow-sm"
                          : `border hover:border-gray-300 ${isDark ? 'border-gray-700 bg-gray-800' : 'border-gray-200 bg-white'}`
                      }`}
                      style={{
                        backgroundColor:
                          sortBy === option.value
                            ? theme?.primaryColor + "10" || "#f0f2ff"
                            : inactiveBtnBg,
                        borderColor:
                          sortBy === option.value
                            ? theme?.primaryColor || "#4f46e5"
                            : "",
                        color:
                          sortBy === option.value
                            ? theme?.primaryColor || "#4f46e5"
                            : labelColor,
                      }}
                    >
                      <span className='text-[10px] sm:text-xs font-bold'>{option.icon}</span>
                      <span className='text-[10px] sm:text-xs truncate'>{option.label}</span>
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Availability Section */}
          <div className={`${sectionBg} rounded-lg`}>
            <button
              onClick={() => setIsAvailabilityOpen(!isAvailabilityOpen)}
              className='w-full p-2.5 sm:p-3 flex justify-between items-center rounded-lg transition-colors'
            >
              <div className='flex items-center gap-2'>
                <div
                  className='p-1 rounded'
                  style={{
                    backgroundColor: theme?.primaryColor + "10" || "#f0f2ff",
                  }}
                >
                  <MdInfoOutline
                    className='text-xs sm:text-sm'
                    style={{ color: theme?.primaryColor || "#4f46e5" }}
                  />
                </div>
                <span
                  className='text-xs sm:text-sm font-medium'
                  style={{ color: headingColor }}
                >
                  {t("STORE.AVAILABILITY")}
                </span>
                {availability !== "all" && (
                  <span className='text-[9px] sm:text-xs px-1.5 py-0.5 rounded-full ml-1 font-normal bg-red-100 text-red-700'>
                    {availability === "in-stock"
                      ? t("STORE.IN_STOCK")
                      : t("STORE.OUT_OF_STOCK")}
                  </span>
                )}
              </div>
              {isAvailabilityOpen ? (
                <MdKeyboardArrowUp className='text-gray-500 text-sm' />
              ) : (
                <MdKeyboardArrowDown className='text-gray-500 text-sm' />
              )}
            </button>

            {isAvailabilityOpen && (
              <div className='px-2 sm:px-3 pb-2 sm:pb-3 pt-1 animate-fade-in'>
                <div className='grid grid-cols-3 gap-1.5 sm:gap-2'>
                  {[
                    { value: "all", label: t("STORE.ALL_ITEMS"), icon: "✓" },
                    {
                      value: "in-stock",
                      label: t("STORE.IN_STOCK"),
                      icon: "✓",
                      color: "green",
                    },
                    {
                      value: "out-of-stock",
                      label: t("STORE.OUT_OF_STOCK"),
                      icon: "✗",
                      color: "red",
                    },
                  ].map((option) => (
                    <button
                      key={option.value}
                      onClick={() => setAvailability(option.value)}
                      className={`py-1.5 sm:py-2 px-1 rounded text-[10px] sm:text-xs font-medium transition-all duration-150 flex flex-col items-center gap-0.5 ${
                        availability === option.value
                          ? "ring-1 ring-offset-1 shadow-sm"
                          : `border ${isDark ? 'border-gray-700' : 'border-gray-200'} hover:border-gray-300`
                      }`}
                      style={{
                        backgroundColor:
                          availability === option.value
                            ? option.color === "green"
                              ? "#dcfce7"
                              : option.color === "red"
                                ? "#fee2e2"
                                : theme?.primaryColor + "10" || "#f0f2ff"
                            : inactiveBtnBg,
                        borderColor:
                          availability === option.value
                            ? option.color === "green"
                              ? "#16a34a"
                              : option.color === "red"
                                ? "#dc2626"
                                : theme?.primaryColor || "#4f46e5"
                            : "",
                        color:
                          availability === option.value
                            ? option.color === "green"
                              ? "#166534"
                              : option.color === "red"
                                ? "#991b1b"
                                : theme?.primaryColor || "#4f46e5"
                            : labelColor,
                      }}
                    >
                      <span className='text-xs sm:text-sm font-bold'>{option.icon}</span>
                      <span className='text-[9px] sm:text-xs'>{option.label}</span>
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Price Range Section */}
          <div className={`${sectionBg} rounded-lg`}>
            <button
              onClick={() => setIsPriceOpen(!isPriceOpen)}
              className='w-full p-2.5 sm:p-3 flex justify-between items-center rounded-lg transition-colors'
            >
              <div className='flex items-center gap-2'>
                <div
                  className='p-1 rounded'
                  style={{
                    backgroundColor: theme?.primaryColor + "10" || "#f0f2ff",
                  }}
                >
                  <MdFilterList
                    className='text-xs sm:text-sm'
                    style={{ color: theme?.primaryColor || "#4f46e5" }}
                  />
                </div>
                <span
                  className='text-xs sm:text-sm font-medium'
                  style={{ color: headingColor }}
                >
                  {t("STORE.PRICE_RANGE")}
                </span>
                {(priceRange[0] > 0 || priceRange[1] < maxPrice) && (
                  <span className='text-[9px] sm:text-xs px-1.5 py-0.5 rounded-full ml-1 font-normal bg-orange-100 text-orange-700'>
                    ₹{priceRange[0]}-₹{priceRange[1]}
                  </span>
                )}
              </div>
              {isPriceOpen ? (
                <MdKeyboardArrowUp className='text-gray-500 text-sm' />
              ) : (
                <MdKeyboardArrowDown className='text-gray-500 text-sm' />
              )}
            </button>

            {isPriceOpen && (
              <div className='px-3 pb-3 pt-1 animate-fade-in'>
                <div className='space-y-4'>
                  <div className='flex justify-between items-center'>
                    <span className='text-[10px] sm:text-xs font-medium' style={{ color: labelColor }}>
                      Min: ₹{priceRange[0].toLocaleString()}
                    </span>
                    <span className='text-[10px] sm:text-xs font-medium' style={{ color: labelColor }}>
                      Max: ₹{priceRange[1].toLocaleString()}
                    </span>
                  </div>

                  <div className='relative pt-5 pb-2'>
                    <div className='absolute h-1 w-full bg-gray-200 rounded-full top-1/2 transform -translate-y-1/2'></div>
                    
                    <div
                      className='absolute h-1 rounded-full top-1/2 transform -translate-y-1/2'
                      style={{
                        left: `${(priceRange[0] / maxPrice) * 100}%`,
                        width: `${((priceRange[1] - priceRange[0]) / maxPrice) * 100}%`,
                        backgroundColor: theme?.primaryColor || "#4f46e5",
                      }}
                    ></div>

                    <div 
                      className='absolute w-full h-8 top-1/2 transform -translate-y-1/2 cursor-pointer z-10'
                      onClick={(e) => {
                        const rect = e.currentTarget.getBoundingClientRect();
                        const x = e.clientX - rect.left;
                        const percentage = x / rect.width;
                        const value = Math.round(percentage * maxPrice / 100) * 100;
                        
                        const distToMin = Math.abs(value - priceRange[0]);
                        const distToMax = Math.abs(value - priceRange[1]);
                        
                        if (distToMin < distToMax) {
                          if (value <= priceRange[1]) {
                            setPriceRange([value, priceRange[1]]);
                          }
                        } else {
                          if (value >= priceRange[0]) {
                            setPriceRange([priceRange[0], value]);
                          }
                        }
                      }}
                    />

                    <div
                      className='absolute w-5 h-5 rounded-full shadow-lg -translate-x-1/2 -translate-y-1/2 z-20'
                      style={{
                        left: `${(priceRange[0] / maxPrice) * 100}%`,
                        top: '50%',
                        backgroundColor: theme?.primaryColor || "#4f46e5",
                        cursor: 'grab',
                      }}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        const startX = e.clientX;
                        const startValue = priceRange[0];
                        const sliderWidth = e.currentTarget.parentElement.offsetWidth;
                        
                        const handleMouseMove = (moveEvent) => {
                          moveEvent.preventDefault();
                          const dx = moveEvent.clientX - startX;
                          const deltaValue = (dx / sliderWidth) * maxPrice;
                          let newValue = startValue + deltaValue;
                          newValue = Math.max(0, Math.min(newValue, priceRange[1]));
                          newValue = Math.round(newValue / 100) * 100;
                          setPriceRange([newValue, priceRange[1]]);
                        };
                        
                        const handleMouseUp = () => {
                          document.removeEventListener('mousemove', handleMouseMove);
                          document.removeEventListener('mouseup', handleMouseUp);
                        };
                        
                        document.addEventListener('mousemove', handleMouseMove);
                        document.addEventListener('mouseup', handleMouseUp);
                      }}
                      onTouchStart={(e) => {
                        e.preventDefault();
                        const startX = e.touches[0].clientX;
                        const startValue = priceRange[0];
                        const sliderWidth = e.currentTarget.parentElement.offsetWidth;
                        
                        const handleTouchMove = (moveEvent) => {
                          moveEvent.preventDefault();
                          const dx = moveEvent.touches[0].clientX - startX;
                          const deltaValue = (dx / sliderWidth) * maxPrice;
                          let newValue = startValue + deltaValue;
                          newValue = Math.max(0, Math.min(newValue, priceRange[1]));
                          newValue = Math.round(newValue / 100) * 100;
                          setPriceRange([newValue, priceRange[1]]);
                        };
                        
                        const handleTouchEnd = () => {
                          document.removeEventListener('touchmove', handleTouchMove);
                          document.removeEventListener('touchend', handleTouchEnd);
                        };
                        
                        document.addEventListener('touchmove', handleTouchMove);
                        document.addEventListener('touchend', handleTouchEnd);
                      }}
                    >
                      <div className='absolute inset-0 rounded-full border-2 border-white'></div>
                    </div>

                    <div
                      className='absolute w-5 h-5 rounded-full shadow-lg -translate-x-1/2 -translate-y-1/2 z-20'
                      style={{
                        left: `${(priceRange[1] / maxPrice) * 100}%`,
                        top: '50%',
                        backgroundColor: theme?.primaryColor || "#4f46e5",
                        cursor: 'grab',
                      }}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        const startX = e.clientX;
                        const startValue = priceRange[1];
                        const sliderWidth = e.currentTarget.parentElement.offsetWidth;
                        
                        const handleMouseMove = (moveEvent) => {
                          moveEvent.preventDefault();
                          const dx = moveEvent.clientX - startX;
                          const deltaValue = (dx / sliderWidth) * maxPrice;
                          let newValue = startValue + deltaValue;
                          newValue = Math.max(priceRange[0], Math.min(newValue, maxPrice));
                          newValue = Math.round(newValue / 100) * 100;
                          setPriceRange([priceRange[0], newValue]);
                        };
                        
                        const handleMouseUp = () => {
                          document.removeEventListener('mousemove', handleMouseMove);
                          document.removeEventListener('mouseup', handleMouseUp);
                        };
                        
                        document.addEventListener('mousemove', handleMouseMove);
                        document.addEventListener('mouseup', handleMouseUp);
                      }}
                      onTouchStart={(e) => {
                        e.preventDefault();
                        const startX = e.touches[0].clientX;
                        const startValue = priceRange[1];
                        const sliderWidth = e.currentTarget.parentElement.offsetWidth;
                        
                        const handleTouchMove = (moveEvent) => {
                          moveEvent.preventDefault();
                          const dx = moveEvent.touches[0].clientX - startX;
                          const deltaValue = (dx / sliderWidth) * maxPrice;
                          let newValue = startValue + deltaValue;
                          newValue = Math.max(priceRange[0], Math.min(newValue, maxPrice));
                          newValue = Math.round(newValue / 100) * 100;
                          setPriceRange([priceRange[0], newValue]);
                        };
                        
                        const handleTouchEnd = () => {
                          document.removeEventListener('touchmove', handleTouchMove);
                          document.removeEventListener('touchend', handleTouchEnd);
                        };
                        
                        document.addEventListener('touchmove', handleTouchMove);
                        document.addEventListener('touchend', handleTouchEnd);
                      }}
                    >
                      <div className='absolute inset-0 rounded-full border-2 border-white'></div>
                    </div>
                  </div>

                  <div className='flex items-center gap-2'>
                    <div className='flex-1'>
                      <div className='relative'>
                        <span className='absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500 text-[10px] sm:text-xs'>
                          ₹
                        </span>
                        <input
                          type='number'
                          value={priceRange[0]}
                          onChange={(e) => {
                            let value = Number(e.target.value);
                            if (isNaN(value)) value = 0;
                            value = Math.max(0, Math.min(value, priceRange[1]));
                            value = Math.round(value / 100) * 100;
                            setPriceRange([value, priceRange[1]]);
                          }}
                          className='w-full pl-6 pr-2 py-1.5 text-[10px] sm:text-xs border rounded focus:outline-none focus:ring-1'
                          placeholder='Min'
                          min='0'
                          max={priceRange[1]}
                          step='100'
                          style={{
                            borderColor: theme?.primaryColor + "30" || "#e5e7eb",
                            fontFamily: theme?.fontFamily || "Inter",
                          }}
                        />
                      </div>
                    </div>
                    <div className='text-gray-400 text-[10px] sm:text-xs'>to</div>
                    <div className='flex-1'>
                      <div className='relative'>
                        <span className='absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500 text-[10px] sm:text-xs'>
                          ₹
                        </span>
                        <input
                          type='number'
                          value={priceRange[1]}
                          onChange={(e) => {
                            let value = Number(e.target.value);
                            if (isNaN(value)) value = maxPrice;
                            value = Math.max(priceRange[0], Math.min(value, maxPrice));
                            value = Math.round(value / 100) * 100;
                            setPriceRange([priceRange[0], value]);
                          }}
                          className='w-full pl-6 pr-2 py-1.5 text-[10px] sm:text-xs border rounded focus:outline-none focus:ring-1'
                          placeholder='Max'
                          min={priceRange[0]}
                          max={maxPrice}
                          step='100'
                          style={{
                            borderColor: theme?.primaryColor + "30" || "#e5e7eb",
                            fontFamily: theme?.fontFamily || "Inter",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Categories Section */}
          <div className={`${sectionBg} rounded-lg`}>
            <button
              onClick={() => setIsCategoryOpen(!isCategoryOpen)}
              className='w-full p-2.5 sm:p-3 flex justify-between items-center rounded-lg transition-colors'
            >
              <div className='flex items-center gap-2'>
                <div
                  className='p-1 rounded'
                  style={{
                    backgroundColor: theme?.primaryColor + "10" || "#f0f2ff",
                  }}
                >
                  <MdList
                    className='text-xs sm:text-sm'
                    style={{ color: theme?.primaryColor || "#4f46e5" }}
                  />
                </div>
                <span
                  className='text-xs sm:text-sm font-medium'
                  style={{ color: headingColor }}
                >
                  {t("STORE.CATAGORIES")}
                </span>
                {selectedCategories.length > 0 && (
                  <span
                    className='text-[9px] sm:text-xs px-1.5 py-0.5 rounded-full ml-1 font-normal'
                    style={{
                      backgroundColor: theme?.primaryColor + "20" || "#e0e7ff",
                      color: theme?.primaryColor || "#4f46e5",
                    }}
                  >
                    {selectedCategories.length}
                  </span>
                )}
              </div>
              {isCategoryOpen ? (
                <MdKeyboardArrowUp className='text-gray-500 text-sm' />
              ) : (
                <MdKeyboardArrowDown className='text-gray-500 text-sm' />
              )}
            </button>

            {isCategoryOpen && (
              <div className='px-2 sm:px-3 pb-2 sm:pb-3 pt-1 animate-fade-in'>
                <div className='relative mb-2 sm:mb-3'>
                  <MdSearch className='absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs' />
                  <input
                    type='text'
                    placeholder={
                      t("STORE.SEARCH_CATEGORIES_PLACEHOLDER") ||
                      "Search categories..."
                    }
                    value={categorySearch}
                    onChange={(e) => setCategorySearch(e.target.value)}
                    className='w-full pl-8 pr-3 py-1.5 text-[10px] sm:text-xs border rounded focus:outline-none focus:ring-1'
                    style={{
                      borderColor: theme?.primaryColor + "30" || "#e5e7eb",
                      fontFamily: theme?.fontFamily || "Inter",
                    }}
                  />
                </div>

                <div className='flex justify-between items-center mb-2'>
                  <span className='text-[10px] sm:text-xs' style={{ color: mutedColor }}>
                    {filteredCategories.length} {t("STORE.CATEGORIES")}
                  </span>
                  <div className='flex gap-1'>
                    <button
                      onClick={selectAllCategories}
                      className={`text-[10px] sm:text-xs px-2 py-0.5 rounded border ${hoverBgClass} transition-colors`}
                      style={{
                        borderColor: theme?.primaryColor + "30" || "#e5e7eb",
                        color: labelColor,
                      }}
                    >
                      {t("STORE.SELECT_ALL")}
                    </button>
                    <button
                      onClick={clearAllCategories}
                      className={`text-[10px] sm:text-xs px-2 py-0.5 rounded border ${hoverBgClass} transition-colors`}
                      style={{
                        borderColor: theme?.primaryColor + "30" || "#e5e7eb",
                        color: labelColor,
                      }}
                    >
                      {t("STORE.CLEAR_ALL")}
                    </button>
                  </div>
                </div>

                <div className='space-y-1 max-h-48 overflow-y-auto pr-1'>
                  {filteredCategories.length > 0 ? (
                    filteredCategories.map((category) => {
                      const hasSubcategories =
                        categorySubcategoryMap[category]?.size > 0;
                      const isExpanded = expandedCategory === category;

                      return (
                        <div key={category} className='space-y-1'>
                          <div className='flex items-center justify-between'>
                            <label className={`flex items-center gap-2 p-1.5 rounded ${hoverBgClass} cursor-pointer flex-1`}>
                              <input
                                type='checkbox'
                                checked={selectedCategories.includes(category)}
                                onChange={() => toggleCategory(category)}
                                className='rounded border-gray-300'
                                style={{
                                  accentColor: theme?.primaryColor || "#4f46e5",
                                }}
                              />
                              <span
                                className='text-xs sm:text-sm'
                                style={{ color: labelColor }}
                              >
                                {category}
                                {hasSubcategories && (
                                  <span className='text-[10px] sm:text-xs text-gray-500 ml-1'>
                                    ({categorySubcategoryMap[category]?.size})
                                  </span>
                                )}
                              </span>
                            </label>

                            {hasSubcategories && (
                              <button
                                onClick={() =>
                                  setExpandedCategory(
                                    isExpanded ? null : category,
                                  )
                                }
                                className={`p-1 ${isDark ? 'hover:bg-gray-700' : 'hover:bg-gray-200'} rounded`}
                                style={{
                                  color: theme?.textColor + "80" || "#6b7280",
                                }}
                              >
                                {isExpanded ? (
                                  <MdKeyboardArrowUp size={14} />
                                ) : (
                                  <MdKeyboardArrowDown size={14} />
                                )}
                              </button>
                            )}
                          </div>

                          {isExpanded && hasSubcategories && (
                            <div
                              className='ml-6 pl-2 border-l-2'
                              style={{
                                borderColor:
                                  theme?.primaryColor + "20" || "#e0e7ff",
                              }}
                            >
                              <div className='text-[10px] sm:text-xs mb-1' style={{ color: mutedColor }}>
                                {t("STORE.SUBCATEGORIES_COLON")}:
                              </div>
                              {Array.from(categorySubcategoryMap[category]).map(
                                (subcategory) => (
                                  <label
                                    key={subcategory}
                                    className={`flex items-center gap-2 p-1 rounded ${hoverBgClass} cursor-pointer ml-2`}
                                  >
                                    <input
                                      type='checkbox'
                                      checked={selectedSubcategories.includes(
                                        subcategory,
                                      )}
                                      onChange={() =>
                                        toggleSubcategory(subcategory)
                                      }
                                      className='rounded border-gray-300'
                                      style={{
                                        accentColor:
                                          theme?.secondaryColor || "#10b981",
                                      }}
                                    />
                                    <span
                                      className='text-[10px] sm:text-xs'
                                      style={{
                                        color: labelColor,
                                      }}
                                    >
                                      {subcategory}
                                    </span>
                                  </label>
                                ),
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <div className='text-center py-2'>
                      <p className='text-[10px] sm:text-xs text-gray-500'>
                        {t("STORE.NO_CATAGORIES_FOUND")}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* Subcategories Section */}
          <div className={`${isDark ? 'bg-gray-800/50' : 'bg-white'} rounded-lg`}>
              <button
                onClick={() => setIsSubcategoryOpen(!isSubcategoryOpen)}
                className='w-full p-2.5 sm:p-3 flex justify-between items-center rounded-lg transition-colors'
              >
                <div className='flex items-center gap-2'>
                  <div
                    className='p-1 rounded'
                    style={{
                      backgroundColor:
                        theme?.secondaryColor + "10" || "#d1fae5",
                    }}
                  >
                    <MdList
                      className='text-xs sm:text-sm'
                      style={{ color: theme?.secondaryColor || "#10b981" }}
                    />
                  </div>
                  <span
                    className='text-xs sm:text-sm font-medium'
                    style={{ color: headingColor }}
                  >
                    {t("STORE.SUBCATEGORIES")}
                  </span>
                  {selectedSubcategories.length > 0 && (
                    <span
                      className='text-[9px] sm:text-xs px-1.5 py-0.5 rounded-full ml-1 font-normal'
                      style={{
                        backgroundColor:
                          theme?.secondaryColor + "20" || "#a7f3d0",
                        color: theme?.secondaryColor || "#059669",
                      }}
                    >
                      {selectedSubcategories.length}
                    </span>
                  )}
                </div>
                {isSubcategoryOpen ? (
                  <MdKeyboardArrowUp className='text-gray-500 text-sm' />
                ) : (
                  <MdKeyboardArrowDown className='text-gray-500 text-sm' />
                )}
              </button>

              {isSubcategoryOpen && (
                <div className='px-2 sm:px-3 pb-2 sm:pb-3 pt-1 animate-fade-in'>
                  <div className='flex justify-between items-center mb-2'>
                    <span className='text-[10px] sm:text-xs' style={{ color: mutedColor }}>
                      {availableSubcategories.length}{" "}
                      {t("STORE.SUBCATEGORIES_LOWER")}
                    </span>
                    <div className='flex gap-1'>
                      <button
                        onClick={selectAllSubcategories}
                        className={`text-[10px] sm:text-xs px-2 py-0.5 rounded border ${hoverBgClass} transition-colors`}
                        style={{
                          borderColor:
                            theme?.secondaryColor + "30" || "#a7f3d0",
                          color: theme?.secondaryColor || "#059669",
                        }}
                      >
                        {t("STORE.SELECT_ALL")}
                      </button>
                      <button
                        onClick={clearAllSubcategories}
                        className={`text-[10px] sm:text-xs px-2 py-0.5 rounded border ${hoverBgClass} transition-colors`}
                        style={{
                          borderColor:
                            theme?.secondaryColor + "30" || "#a7f3d0",
                          color: theme?.secondaryColor || "#059669",
                        }}
                      >
                        {t("STORE.CLEAR_ALL")}
                      </button>
                    </div>
                  </div>

                  <div className='max-h-48 overflow-y-auto space-y-1 pr-1'>
                    {availableSubcategories.length > 0 ? (
                      availableSubcategories.map((subcategory) => (
                        <label
                          key={subcategory}
                          className={`flex items-center gap-2 p-1.5 rounded ${hoverBgClass} cursor-pointer`}
                        >
                          <input
                            type='checkbox'
                            checked={selectedSubcategories.includes(
                              subcategory,
                            )}
                            onChange={() => toggleSubcategory(subcategory)}
                            className='rounded border-gray-300'
                            style={{
                              accentColor: theme?.secondaryColor || "#10b981",
                            }}
                          />
                          <span
                            className='text-xs sm:text-sm'
                            style={{ color: labelColor }}
                          >
                            {subcategory}
                          </span>
                        </label>
                      ))
                    ) : (
                      <div className='text-center py-2'>
                        <p className='text-[10px] sm:text-xs text-gray-500'>
                          {t("STORE.NO_SUBCATAGORIES_FOUND")}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

          {/* Brands Section */}
          {brands.length > 0 && (
            <div className={`${sectionBg} rounded-lg`}>
              <button
                onClick={() => setIsBrandOpen(!isBrandOpen)}
                className='w-full p-2.5 sm:p-3 flex justify-between items-center rounded-lg transition-colors'
              >
                <div className='flex items-center gap-2'>
                  <div className='p-1 rounded bg-purple-100'>
                    <MdStore className='text-xs sm:text-sm text-purple-600' />
                  </div>
                  <span
                    className='text-xs sm:text-sm font-medium'
                    style={{ color: headingColor }}
                  >
                    {t("STORE.BRAND")}
                  </span>
                  {selectedBrands.length > 0 && (
                    <span className='text-[9px] sm:text-xs px-1.5 py-0.5 rounded-full ml-1 font-normal bg-purple-100 text-purple-700'>
                      {selectedBrands.length}
                    </span>
                  )}
                </div>
                {isBrandOpen ? (
                  <MdKeyboardArrowUp className='text-gray-500 text-sm' />
                ) : (
                  <MdKeyboardArrowDown className='text-gray-500 text-sm' />
                )}
              </button>

              {isBrandOpen && (
                <div className='px-2 sm:px-3 pb-2 sm:pb-3 pt-1 animate-fade-in'>
                  <div className='relative mb-2 sm:mb-3'>
                    <MdSearch className='absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs' />
                    <input
                      type='text'
                      placeholder={
                        t("STORE.SEARCH_BRANDS_PLACEHOLDER") ||
                        "Search brands..."
                      }
                      value={brandSearch}
                      onChange={(e) => setBrandSearch(e.target.value)}
                      className='w-full pl-8 pr-3 py-1.5 text-[10px] sm:text-xs border rounded focus:outline-none focus:ring-1 border-purple-200'
                      style={{
                        fontFamily: theme?.fontFamily || "Inter",
                      }}
                    />
                  </div>

                  <div className='flex justify-between items-center mb-2'>
                    <span className='text-[10px] sm:text-xs' style={{ color: mutedColor }}>
                      {filteredBrands.length} {t("STORE.BRAND")}
                    </span>
                    <div className='flex gap-1'>
                      <button
                        onClick={selectAllBrands}
                        className={`text-[10px] sm:text-xs px-2 py-0.5 rounded border ${hoverBgClass} transition-colors border-purple-200 text-purple-700`}
                      >
                        {t("STORE.SELECT_ALL")}
                      </button>
                      <button
                        onClick={clearAllBrands}
                        className={`text-[10px] sm:text-xs px-2 py-0.5 rounded border ${hoverBgClass} transition-colors border-purple-200 text-purple-700`}
                      >
                        {t("STORE.CLEAR_ALL")}
                      </button>
                    </div>
                  </div>

                  <div className='max-h-48 overflow-y-auto space-y-1 pr-1'>
                    {filteredBrands.length > 0 ? (
                      filteredBrands.map((brand) => (
                        <label
                          key={brand}
                          className={`flex items-center gap-2 p-1.5 rounded ${hoverBgClass} cursor-pointer`}
                        >
                          <input
                            type='checkbox'
                            checked={selectedBrands.includes(brand)}
                            onChange={() => toggleBrand(brand)}
                            className='rounded border-gray-300'
                            style={{
                              accentColor: "#9333ea",
                            }}
                          />
                          <span
                            className='text-xs sm:text-sm'
                            style={{ color: labelColor }}
                          >
                            {brand}
                          </span>
                        </label>
                      ))
                    ) : (
                      <div className='text-center py-2'>
                        <p className='text-[10px] sm:text-xs text-gray-500'>
                          {t("STORE.NO_BRAND_FOUND")}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Active Filters Summary */}
          {(selectedCategories.length > 0 ||
            selectedSubcategories.length > 0 ||
            selectedBrands.length > 0 ||
            priceRange[0] > 0 ||
            priceRange[1] < maxPrice ||
            availability !== "all") && (
            <div className='bg-white p-2.5 sm:p-3 rounded-lg border border-gray-200'>
              <h4
                className='text-[10px] sm:text-xs font-medium mb-2 flex items-center gap-1'
                style={{ color: theme?.headingColor || "#111827" }}
              >
                <MdFilterList size={12} />
                {t("STORE.ACTIVE_FILTERS")}
              </h4>
              <div className='flex flex-wrap gap-1'>
                {selectedCategories.map((category) => (
                  <div
                    key={category}
                    className='inline-flex items-center gap-0.5 px-2 py-0.5 rounded-full text-[10px] sm:text-xs font-medium bg-blue-50 text-blue-700'
                  >
                    {category}
                    <button
                      onClick={() => toggleCategory(category)}
                      className='ml-0.5 hover:text-blue-900 text-xs'
                    >
                      ×
                    </button>
                  </div>
                ))}
                {selectedSubcategories.map((subcategory) => (
                  <div
                    key={subcategory}
                    className='inline-flex items-center gap-0.5 px-2 py-0.5 rounded-full text-[10px] sm:text-xs font-medium bg-green-50 text-green-700'
                  >
                    {subcategory}
                    <button
                      onClick={() => toggleSubcategory(subcategory)}
                      className='ml-0.5 hover:text-green-900 text-xs'
                    >
                      ×
                    </button>
                  </div>
                ))}
                {selectedBrands.map((brand) => (
                  <div
                    key={brand}
                    className='inline-flex items-center gap-0.5 px-2 py-0.5 rounded-full text-[10px] sm:text-xs font-medium bg-purple-50 text-purple-700'
                  >
                    {brand}
                    <button
                      onClick={() => toggleBrand(brand)}
                      className='ml-0.5 hover:text-purple-900 text-xs'
                    >
                      ×
                    </button>
                  </div>
                ))}
                {(priceRange[0] > 0 || priceRange[1] < maxPrice) && (
                  <div className='inline-flex items-center gap-0.5 px-2 py-0.5 rounded-full text-[10px] sm:text-xs font-medium bg-orange-50 text-orange-700'>
                    ₹{priceRange[0]}-₹{priceRange[1]}
                    <button
                      onClick={() => setPriceRange([0, maxPrice])}
                      className='ml-0.5 hover:text-orange-900 text-xs'
                    >
                      ×
                    </button>
                  </div>
                )}
                {availability !== "all" && (
                  <div className='inline-flex items-center gap-0.5 px-2 py-0.5 rounded-full text-[10px] sm:text-xs font-medium bg-red-50 text-red-700'>
                    {availability === "in-stock"
                      ? t("STORE.IN_STOCK")
                      : t("STORE.OUT_OF_STOCK")}
                    <button
                      onClick={() => setAvailability("all")}
                      className='ml-0.5 hover:text-red-900 text-xs'
                    >
                      ×
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Footer Actions */}
        <div className={`sticky bottom-0 p-3 sm:p-4 border-t ${isDark ? 'bg-gray-900 border-gray-800' : 'bg-white border-gray-100'}`}
             style={{ backgroundColor: theme?.backgroundColor }}>
          <div className='grid grid-cols-2 gap-2 sm:gap-3'>
            <button
              onClick={clearFilters}
              className={`py-2 sm:py-2.5 border rounded text-xs sm:text-sm font-medium ${isDark ? 'hover:bg-gray-800' : 'hover:bg-gray-50'} transition-all duration-150 flex items-center justify-center gap-1`}
              style={{
                fontFamily: theme?.fontFamily || "Inter",
                borderColor: theme?.primaryColor + "30" || "#e5e7eb",
                color: theme?.textColor || "#1f2937",
                borderRadius:
                  theme?.buttonStyle === "pill"
                    ? "9999px"
                    : theme?.buttonStyle === "rounded"
                      ? "8px"
                      : "4px",
              }}
            >
              <MdClose size={14} className="sm:text-base" />
              {t("STORE.CLEAR_ALL")}
            </button>
            <button
              onClick={applyFilters}
              className='py-2 sm:py-2.5 text-white rounded text-xs sm:text-sm font-medium hover:opacity-90 transition-all duration-150 flex items-center justify-center gap-1 shadow-md'
              style={{
                backgroundColor: theme?.buttonColor || "#4f46e5",
                borderRadius:
                  theme?.buttonStyle === "pill"
                    ? "9999px"
                    : theme?.buttonStyle === "rounded"
                      ? "8px"
                      : "4px",
                fontFamily: theme?.fontFamily || "Inter",
              }}
            >
              <MdFilterList size={14} className="sm:text-base" />
              {t("STORE.APPLY_FILTERS")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


// Main StoreFrontPage Component
export default function StoreFrontPage() {
  const { businessName: urlBusinessName, bussinessUuid } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();
  const [storeInfo, setStoreInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [allProducts, setAllProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [allServices, setAllServices] = useState([]);
  const [filteredServices, setFilteredServices] = useState([]);
  const [storeDescription, setStoreDescription] = useState(null);
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem(`cart_${bussinessUuid}`);
    return savedCart ? JSON.parse(savedCart) : [];
  });

  const [accountDialogOpen, setAccountDialogOpen] = useState(false);
  const wishlistItems = useSelector((state) => state.wishlist?.items || []);
  const wishlistLoading = useSelector((state) => state.wishlist?.isLoading || false);
  const wishlistCount = wishlistItems.length;
  const [userProfile, setUserProfile] = useState(() => {
    const savedGuest = localStorage.getItem(`guest_${bussinessUuid}`);
    const savedUser = localStorage.getItem(`user_${bussinessUuid}`);
    return savedUser
      ? JSON.parse(savedUser)
      : savedGuest
        ? JSON.parse(savedGuest)
        : null;
  });

  const [activeTab, setActiveTab] = useState("products");
  const [error, setError] = useState();
  const [storeTheme, setStoreTheme] = useState(null);
  const [themeSelection, setThemeSelection] = useState(null);
  const [storeBanner, setStoreBanner] = useState(null);
  const [showOverview, setShowOverview] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [autoOpenAccountDialog, setAutoOpenAccountDialog] = useState(false);
  const [filterPanelOpen, setFilterPanelOpen] = useState(false);
  const [toasts, setToasts] = useState([]);
  const [mobileSideMenuOpen, setMobileSideMenuOpen] = useState(false);
  const businessData = useSelector((state) => state.bussiness.business);
  const business = Array.isArray(businessData)
    ? businessData.find((b) => b.bussinessUuid === bussinessUuid) || businessData[0]
    : businessData;

  // NEW: Call & WhatsApp Settings State
  const [showCallButton, setShowCallButton] = useState(true);
  const [showWhatsappButton, setShowWhatsappButton] = useState(true);
  const [callPhoneNumber, setCallPhoneNumber] = useState('');
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [whatsappMessage, setWhatsappMessage] = useState('');

  const displayBusinessName =
    urlBusinessName || business?.businessName || t("STORE.DEFAULT_STORE_NAME");
     const routeBusinessName = urlBusinessName || storeInfo?.businessName || business?.businessName || "";
  const overviewContent = t("STORE.STORE_OVERVIEW_FALLBACK");

  useEffect(() => {
    const preferredLanguage =
      localStorage.getItem(`storefront_lng_${bussinessUuid}`) ||
      localStorage.getItem("lng") ||
      storeInfo?.language ||
      business?.language ||
      "en";

    if (preferredLanguage && i18n.language !== preferredLanguage) {
      i18n.changeLanguage(preferredLanguage);
    }
  }, [bussinessUuid, business?.language, i18n, storeInfo?.language]);
 useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    if (tab === 'services' || tab === 'products') {
      setActiveTab(tab);
    }
  }, [location.search]);
  useEffect(() => {
    const loadStoreData = async () => {
      setLoading(true);
      setError(undefined);

      try {
        const res = await getBusiness(bussinessUuid);
        const businessData = res?.data || null;
        if (res.data) {
          setStoreInfo(res.data);
          // Set initial phone numbers from business data
          setCallPhoneNumber(res.data?.phone || '');
          setWhatsappNumber(res.data?.phone || '');
        }

        try {
          const settingsResponse = await storeSettingsService.getPublicStoreSettings(bussinessUuid);

          if (settingsResponse.success) {
            const settings = settingsResponse.data;
            const resolvedTheme = shouldUseBusinessDefaultTheme(settings.theme)
              ? getBusinessTypeDefaultTheme(businessData)
              : settings.theme;
            setStoreTheme(resolvedTheme);
            setThemeSelection(settings.themeSelection || null);
            setStoreBanner(settings.bannerImage || settings.banner || null);
            
            if (settings.storeDescription) {
              setStoreDescription(settings.storeDescription);
            }

            // NEW: Load Call & WhatsApp Settings from store settings
            if (settings.callAndWhatsappSettings) {
              setShowCallButton(settings.callAndWhatsappSettings.showCallButton !== false);
              setShowWhatsappButton(settings.callAndWhatsappSettings.showWhatsappButton !== false);
              setCallPhoneNumber(settings.callAndWhatsappSettings.phoneNumber || businessData?.phone || '');
              setWhatsappNumber(settings.callAndWhatsappSettings.whatsappNumber || businessData?.phone || '');
              setWhatsappMessage(settings.callAndWhatsappSettings.whatsappMessage || 'Hi! I am interested in your products.');
            }
          } else {
            console.warn("No store settings found, using defaults");
            setDefaultSettings();
          }
        } catch (settingsError) {
          console.error("Error loading store settings:", settingsError);
          setDefaultSettings(businessData);
        }

        try {
          const result = await getProducts(bussinessUuid);

          let productsData = [];
          if (result.data && result.data.data) {
            productsData = result.data.data;
          } else if (result.data && Array.isArray(result.data)) {
            productsData = result.data;
          } else if (Array.isArray(result)) {
            productsData = result;
          }

          const onlineProducts = productsData.filter(
            (p) => p.enableForOnlineStore === true,
          );

          setAllProducts(onlineProducts);
          setFilteredProducts(onlineProducts);
        } catch (productError) {
          console.error("Error loading products:", productError);
          setAllProducts([]);
          setFilteredProducts([]);
        }

        try {
          const serviceResult = await getServices(bussinessUuid);

          let servicesData = [];
          if (serviceResult.data && serviceResult.data.data) {
            servicesData = serviceResult.data.data;
          } else if (serviceResult.data && Array.isArray(serviceResult.data)) {
            servicesData = serviceResult.data;
          } else if (Array.isArray(serviceResult)) {
            servicesData = serviceResult;
          }

          setAllServices(servicesData);
          setFilteredServices(servicesData);
        } catch (serviceError) {
          console.error("Error loading services:", serviceError);
          setAllServices([]);
          setFilteredServices([]);
        }
      } catch (e) {
        setError(e.message || "Unknown error");
        showToast(t("STORE.ERROR_LOADING_STORE"), "error");
      } finally {
        setLoading(false);
      }
    };

    const setDefaultSettings = (businessData = null) => {
      setStoreTheme(getBusinessTypeDefaultTheme(businessData));
      setThemeSelection({ source: "business-default" });
      setStoreBanner(null);
    };

    loadStoreData();
  }, [bussinessUuid]);

  useEffect(() => {
    if (!storeTheme && storeInfo) {
      setStoreTheme(getBusinessTypeDefaultTheme(storeInfo));
      setThemeSelection({ source: "business-default" });
    }
  }, [storeInfo, storeTheme]);

  useEffect(() => {
    if (bussinessUuid) {
      dispatch(fetchWishlist(bussinessUuid));
    }
  }, [bussinessUuid, dispatch]);

  useEffect(() => {
    if (bussinessUuid) {
      const timer = setTimeout(() => {
        dispatch(fetchWishlist(bussinessUuid));
      }, 500);
      
      return () => clearTimeout(timer);
    }
  }, [userProfile, bussinessUuid, dispatch]);

  useEffect(() => {
    trackPageView("products");
  }, []);

  useEffect(() => {
    const savedUser = localStorage.getItem(`user_${bussinessUuid}`);
    const savedGuest = localStorage.getItem(`guest_${bussinessUuid}`);
    const isB2BIntent = localStorage.getItem("b2b_intent") === "true";

    if (savedUser) {
      try {
        setUserProfile(JSON.parse(savedUser));
        setAutoOpenAccountDialog(false);
      } catch (err) {
        console.error("Error parsing user data:", err);
        localStorage.removeItem(`user_${bussinessUuid}`);
      }
    } else if (savedGuest) {
      try {
        setUserProfile(JSON.parse(savedGuest));
        setAutoOpenAccountDialog(false);
      } catch (err) {
        console.error("Error parsing guest data:", err);
        localStorage.removeItem(`guest_${bussinessUuid}`);
      }
    } else {
      setAutoOpenAccountDialog(true);

      if (isB2BIntent) {
        localStorage.setItem("force_b2b_login", "true");
      }
    }
  }, [bussinessUuid]);

  useEffect(() => {
    let filtered = allProducts;
    if (searchQuery) {
      filtered = filtered.filter(
        (product) =>
          product.productName
            .toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          (product.description &&
            product.description
              .toLowerCase()
              .includes(searchQuery.toLowerCase())),
      );
    }
    setFilteredProducts(filtered);

    if (allServices.length > 0) {
      let filteredServicesList = allServices;
      if (searchQuery) {
        filteredServicesList = allServices.filter(
          (service) =>
            service.serviceName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            service.description?.toLowerCase().includes(searchQuery.toLowerCase())
        );
      }
      setFilteredServices(filteredServicesList);
    }
  }, [searchQuery, allProducts, allServices]);

  const handleGoToWishlist = () => {
    navigate(
      getStorefrontPath({
        businessName: routeBusinessName,
        bussinessUuid,
        suffix: "wishlist",
      }),
    );
  };

  const showToast = (message, type = "success") => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, type }]);
  };

  const removeToast = (id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  };
  
  useEffect(() => {
    const savedUser = localStorage.getItem(`user_${bussinessUuid}`);
    if (!savedUser) {
      localStorage.setItem(`cart_${bussinessUuid}`, JSON.stringify(cart));
    }
  }, [cart, bussinessUuid]);

  const handleAccountLogin = async (user) => {
    try {
      const payload = {
        name: user.name,
        customer_mobile: user.phone,
        email: user.email || "",
      };
      const response = await createCustomer(bussinessUuid, payload);
      let customerData;
      
      if (response?.data) {
        customerData = response.data;
        
        const realCustomerId = customerData.customerId;
        
        customerData = {
          ...customerData,
          customerId: realCustomerId,
          _id: customerData._id || realCustomerId,
          name: customerData.name || user.name,
          customer_mobile: customerData.customer_mobile || user.phone,
          isGuest: false,
          isCustomer: true,
        };
      } else {
        customerData = {
          _id: `cust_${Date.now()}_${user.phone}`,
          customerId: `cust_${Date.now()}_${user.phone}`,
          name: user.name,
          customer_mobile: user.phone,
          isGuest: false,
          isCustomer: true,
          email: user.email || "",
          createdAt: new Date().toISOString(),
          bussinessUuid: bussinessUuid,
        };
      }

      setUserProfile(customerData);

      localStorage.setItem(
        `user_${bussinessUuid}`,
        JSON.stringify(customerData),
      );
      localStorage.removeItem(`guest_${bussinessUuid}`);

      try {
        const cartResponse = await getUserCart(bussinessUuid, customerData.customerId);
        if (cartResponse && cartResponse.success && cartResponse.data && cartResponse.data.items) {
          setCart(cartResponse.data.items);
        }
      } catch (cartError) {
        console.error("Error loading cart after login:", cartError);
      }

      setAccountDialogOpen(false);
      setAutoOpenAccountDialog(false);

      showToast(t("STORE.LOGIN_SUCCESS"));

      setTimeout(() => {
        window.location.reload();
      }, 500);
    } catch (error) {
      console.error("Error in handleAccountLogin:", error);

      const fallbackCustomer = {
        ...user,
        _id: user._id || `cust_fallback_${Date.now()}`,
        isGuest: false,
        isCustomer: true,
        bussinessUuid: bussinessUuid,
      };

      setUserProfile(fallbackCustomer);
      localStorage.setItem(
        `user_${bussinessUuid}`,
        JSON.stringify(fallbackCustomer),
      );
      localStorage.removeItem(`guest_${bussinessUuid}`);

      showToast(t("STORE.LOGIN_SUCCESS"));
      setAccountDialogOpen(false);
      setAutoOpenAccountDialog(false);
    }
  };
  
  const handleGuestMode = () => {
    const guestProfile = {
      _id: `guest_${Date.now()}`,
      name: "Guest",
      phone: "",
      address: "",
      isGuest: true,
      isCustomer: false,
      createdAt: new Date().toISOString(),
    };
    setUserProfile(guestProfile);
    setAccountDialogOpen(false);
    setAutoOpenAccountDialog(false);
    localStorage.setItem(
      `guest_${bussinessUuid}`,
      JSON.stringify(guestProfile),
    );
    showToast(t("STORE.CONTINUING_AS_GUEST"));
  };
  
  useEffect(() => {
    const loadUserCart = async () => {
      if (!bussinessUuid) return;
      
      const savedUser = localStorage.getItem(`user_${bussinessUuid}`);
      if (savedUser) {
        try {
          const userProfile = JSON.parse(savedUser);
          const customerId = userProfile.customerId || userProfile._id;
          
          const response = await getUserCart(bussinessUuid, customerId);
          
          if (response && response.success && response.data && response.data.items) {
            setCart(response.data.items);
          }
        } catch (error) {
          console.error("Error loading user cart:", error);
        }
      }
    };

    loadUserCart();
  }, [bussinessUuid, userProfile]); 
  
  useEffect(() => {
    const savedUser = localStorage.getItem(`user_${bussinessUuid}`);
    const savedGuest = localStorage.getItem(`guest_${bussinessUuid}`);

    if (savedUser) {
      try {
        const parsedUser = JSON.parse(savedUser);

        if (!parsedUser.isGuest) {
          parsedUser.isGuest = false;
        }
        if (!parsedUser.isCustomer && !parsedUser.isGuest) {
          parsedUser.isCustomer = true;
        }

        setUserProfile(parsedUser);
        setAutoOpenAccountDialog(false);
      } catch (err) {
        console.error("Error parsing user data:", err);
        localStorage.removeItem(`user_${bussinessUuid}`);
      }
    } else if (savedGuest) {
      try {
        const parsedGuest = JSON.parse(savedGuest);

        parsedGuest.isGuest = true;
        parsedGuest.isCustomer = false;

        setUserProfile(parsedGuest);
        setAutoOpenAccountDialog(false);
      } catch (err) {
        console.error("Error parsing guest data:", err);
        localStorage.removeItem(`guest_${bussinessUuid}`);
      }
    } else {
      setAutoOpenAccountDialog(true);
    }
  }, [bussinessUuid]);
  
  const handleLogout = () => {
    setUserProfile(null);
    localStorage.removeItem(`user_${bussinessUuid}`);
    localStorage.removeItem(`guest_${bussinessUuid}`);
    const isB2BIntent = localStorage.getItem("b2b_intent") === "true";
    if (isB2BIntent) {
      localStorage.setItem("b2b_Price", "true");
    } else {
      localStorage.setItem("b2b_Price", "false");
    }
    localStorage.removeItem(`force_b2b_login`);
    setCart([]);
    setAutoOpenAccountDialog(true);
    dispatch(clearWishlistState());
    showToast(t("STORE.LOGOUT_SUCCESS"));
  };
  
  const handleAddToCart = (product) => {
    setCart((prev) => {
      if (!product.quantity || product.quantity === 0) {
        toast.error(`${product.productName} is out of stock`);
        return prev;
      }

      const found = prev.find((item) => item._id === product._id);

      if (found) {
        if ((found.cartQuantity || 1) >= product.quantity) {
          toast.error(`${product.productName} reached maximum stock limit`);
          return prev;
        }

        const updatedCart = prev.map((item) =>
          item._id === product._id
            ? { ...item, cartQuantity: (item.cartQuantity || 1) + 1 }
            : item,
        );
        localStorage.setItem(
          `cart_${bussinessUuid}`,
          JSON.stringify(updatedCart),
        );
        toast.success(`${product.productName} quantity increased in cart`);
        return updatedCart;
      }

      const newCart = [...prev, { ...product, cartQuantity: 1 }];
      localStorage.setItem(`cart_${bussinessUuid}`, JSON.stringify(newCart));
      toast.success(`${product.productName} added to cart`);
      return newCart;
    });
    trackAddToCart({
      businessUuid: bussinessUuid,
      productId: product.productId || product._id,
      contentId: product.productId || product._id,
      contentName: product.productName,
      value: Number(product.salePrice || product.mrp || 0),
      currency: "INR",
    });
  };

  const handleOpenCart = () => {
    navigate(
      getStorefrontPath({
        businessName: routeBusinessName,
        bussinessUuid,
        suffix: "cart",
      }),
    );
  };

  const handleViewOrders = () => {
    navigate(
      getStorefrontPath({
       businessName: routeBusinessName,
        bussinessUuid,
        suffix: "orders",
      }),
    );
  };

  const handleViewProfile = () => {
    navigate(
      getStorefrontPath({
        businessName: routeBusinessName,
        bussinessUuid,
        suffix: "profile",
      }),
    );
  };

  const handleOpenLogin = () => {
    setAccountDialogOpen(true);
  };

  const handleBackToLanding = () => {
    navigate(
      getLandingPagePath({
        businessName: routeBusinessName,
        bussinessUuid,
      }),
    );
  };

  const themeStyles = {
    fontFamily:
      storeTheme?.fontFamily || "Inter, system-ui, -apple-system, sans-serif",
    backgroundColor: storeTheme?.backgroundColor || "#f9fafb",
    color: storeTheme?.textColor || "#1f2937",
  };

  const headingStyle = {
    color: storeTheme?.headingColor || "#111827",
    fontFamily:
      storeTheme?.fontFamily || "Inter, system-ui, -apple-system, sans-serif",
  };

  const buttonStyle = {
    backgroundColor: storeTheme?.buttonColor || "#4f46e5",
    color: "#ffffff",
    borderRadius:
      storeTheme?.buttonStyle === "pill"
        ? "9999px"
        : storeTheme?.buttonStyle === "rounded"
          ? "8px"
          : "4px",
    fontFamily:
      storeTheme?.fontFamily || "Inter, system-ui, -apple-system, sans-serif",
  };

  const activeThemeSource = themeSelection?.source || "business-default";
  const isCustomStorefrontTheme = activeThemeSource === "custom";
  const themeLayoutPreset = isCustomStorefrontTheme ? {} : (storeTheme?.layoutPreset || {});
  const storefrontPreset = isCustomStorefrontTheme ? getStorefrontThemePreset({}) : getStorefrontThemePreset(storeTheme || {});
  const resolvedThemeId = isCustomStorefrontTheme ? "" : resolveThemeId(storeTheme || {});
  const heroVariant =
    (isCustomStorefrontTheme ? "classic" : themeLayoutPreset.heroVariant) ||
    storeTheme?.heroVariant ||
    storefrontPreset.heroVariant ||
    "classic";
  const shouldUseStoreBanner = typeof storeTheme?.hideBanner === "boolean"
    ? !storeTheme.hideBanner
    : !storefrontPreset.hideBanner;

  const resolvedProductVariant =
    (isCustomStorefrontTheme ? "grid" : themeLayoutPreset.productVariant) ||
    storeTheme?.productVariant ||
    storefrontPreset.productVariant ||
    "grid";

  const getThemePreviewImage = () => {
    if (storeTheme?.themePreviewImage) return storeTheme.themePreviewImage;
    const resolvedId = resolveThemeId(storeTheme || {});
    return THEME_IMAGES[resolvedId] || THEME_IMAGES.dawn || null;
  };

  const getBannerUrl = () => {
    if (storeBanner) {
      if (storeBanner.type === "color") {
        return null;
      } else if (storeBanner.type === "image" && storeBanner.imageUrl) {
        let url = storeBanner.imageUrl;

        if (
          url &&
          !url.startsWith("http") &&
          !url.startsWith("https") &&
          url.includes("/")
        ) {
          url = `https://dukanbuddy-normal.s3.us-east-1.amazonaws.com/${url}`;
        }

        return url;
      }
    }

    if (storeInfo?.bannerImage) {
      let url = storeInfo.bannerImage;
      if (url && !url.startsWith("http") && !url.startsWith("https")) {
        if (url.startsWith("/")) {
          url = `${window.location.origin}${url}`;
        } else {
          if (url.includes("/")) {
            url = `https://dukanbuddy-normal.s3.us-east-1.amazonaws.com/${url}`;
          } else {
            url = `${AWS_URL}${url}`;
          }
        }
      }
      return url;
    }

    return ImageTen;
  };

  // Mobile Side Menu Component
  const MobileSideMenu = () => (
    <>
      {/* Overlay */}
      {mobileSideMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-50 lg:hidden"
          onClick={() => setMobileSideMenuOpen(false)}
        />
      )}
      
      {/* Side Menu */}
      <div
        className={`fixed top-0 left-0 h-full w-80 max-w-[85vw] bg-white shadow-xl z-50 transform transition-transform duration-300 ease-in-out lg:hidden ${
          mobileSideMenuOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
        style={{
          backgroundColor: storeTheme?.backgroundColor || '#ffffff',
        }}
      >
        <div className="flex flex-col h-full">
          {/* Menu Header */}
          <div 
            className="p-4 border-b flex items-center justify-between"
            style={{ borderColor: isDarkTheme(storeTheme) ? '#374151' : '#e5e7eb' }}
          >
            <div className="flex items-center gap-3">
              {storeInfo?.logo ? (
                <img 
                  src={storeInfo.logo} 
                  alt={displayBusinessName}
                  className="w-10 h-10 rounded-full object-cover"
                />
              ) : (
                <div 
                  className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-lg"
                  style={{ backgroundColor: storeTheme?.primaryColor || '#4f46e5' }}
                >
                  {displayBusinessName?.charAt(0)?.toUpperCase() || 'S'}
                </div>
              )}
              <div>
                <h3 
                  className="font-semibold text-base"
                  style={{ color: storeTheme?.headingColor || '#111827' }}
                >
                  {displayBusinessName}
                </h3>
                <span className="text-xs" style={{ color: storeTheme?.textColor || '#6b7280' }}>
                  {t("NEWSLETTER.MENU") || "Menu"}
                </span>
              </div>
            </div>
            <button
              onClick={() => setMobileSideMenuOpen(false)}
              className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
              style={{ color: storeTheme?.textColor || '#4b5563' }}
            >
              <MdClose className="text-xl" />
            </button>
          </div>

          {/* Menu Items */}
          <div className="flex-1 overflow-y-auto py-2">
            {/* Store Navigation */}
            <div className="px-2 mb-4">
              <p 
                className="px-3 py-2 text-xs font-semibold uppercase tracking-wider"
                style={{ color: storeTheme?.primaryColor || '#4f46e5' }}
              >
                {t("NEWSLETTER.NAVIGATION") || "Navigation"}
              </p>
              
              <button
                onClick={() => {
                  setActiveTab('products');
                  setMobileSideMenuOpen(false);
                }}
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg mb-1 transition-colors ${
                  activeTab === 'products' ? 'bg-blue-50' : 'hover:bg-gray-50'
                }`}
                style={{
                  color: activeTab === 'products' ? storeTheme?.primaryColor || '#4f46e5' : storeTheme?.textColor || '#374151',
                  backgroundColor: activeTab === 'products' ? `${storeTheme?.primaryColor}10` || '#eff6ff' : 'transparent'
                }}
              >
                <MdStore className="text-xl" />
                <div className="text-left">
                  <div className="font-medium text-sm">{t("ONLINE_STORE.PRODUCTS") || "Products"}</div>
                  <div className="text-xs opacity-70">{t("NEWSLETTER.BROWSE_PRODUCTS") || "Browse products"}</div>
                </div>
              </button>

              {allServices.length > 0 && (
                <button
                  onClick={() => {
                    setActiveTab('services');
                    setMobileSideMenuOpen(false);
                  }}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg mb-1 transition-colors ${
                    activeTab === 'services' ? 'bg-green-50' : 'hover:bg-gray-50'
                  }`}
                  style={{
                    color: activeTab === 'services' ? storeTheme?.secondaryColor || '#10b981' : storeTheme?.textColor || '#374151',
                    backgroundColor: activeTab === 'services' ? `${storeTheme?.secondaryColor}10` || '#ecfdf5' : 'transparent'
                  }}
                >
                  <MdList className="text-xl" />
                  <div className="text-left">
                    <div className="font-medium text-sm">{t("ONLINE_STORE.SERVICES") || "Services"}</div>
                    <div className="text-xs opacity-70">{t("NEWSLETTER.BROWSE_SERVICES") || "Browse services"}</div>
                  </div>
                </button>
              )}

              <button
                onClick={() => {
                  setShowOverview(true);
                  setMobileSideMenuOpen(false);
                }}
                className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg mb-1 hover:bg-gray-50 transition-colors"
                style={{ color: storeTheme?.textColor || '#374151' }}
              >
                <MdInfoOutline className="text-xl" />
                <div className="text-left">
                  <div className="font-medium text-sm">{t("ONLINE_STORE.ABOUT_US") || "About Us"}</div>
                  <div className="text-xs opacity-70">{t("NEWSLETTER.LEARN_MORE") || "Learn more about us"}</div>
                </div>
              </button>

              <button
                onClick={() => {
                  handleBackToLanding();
                  setMobileSideMenuOpen(false);
                }}
                className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg mb-1 hover:bg-gray-50 transition-colors"
                style={{ color: storeTheme?.textColor || '#374151' }}
              >
                <MdHome className="text-xl" />
                <div className="text-left">
                  <div className="font-medium text-sm">{t("STORE.LANDING") || "Landing Page"}</div>
                  <div className="text-xs opacity-70">{t("STORE.BACK_TO_LANDING_PAGE") || "Go to landing page"}</div>
                </div>
              </button>
            </div>

            {/* Quick Actions */}
            <div className="px-2 mb-4">
              <p 
                className="px-3 py-2 text-xs font-semibold uppercase tracking-wider"
                style={{ color: storeTheme?.primaryColor || '#4f46e5' }}
              >
                {t("NEWSLETTER.QUICK_ACTIONS") || "Quick Actions"}
              </p>
              
              <button
                onClick={() => {
                  handleOpenCart();
                  setMobileSideMenuOpen(false);
                }}
                className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg mb-1 hover:bg-gray-50 transition-colors"
                style={{ color: storeTheme?.textColor || '#374151' }}
              >
                <MdShoppingCart className="text-xl" />
                <div className="text-left flex-1">
                  <div className="font-medium text-sm">{t("STORE.CART") || "Cart"}</div>
                </div>
                {cart.length > 0 && (
                  <span 
                    className="px-2 py-0.5 rounded-full text-xs font-bold text-white"
                    style={{ backgroundColor: storeTheme?.primaryColor || '#4f46e5' }}
                  >
                    {cart.reduce((sum, item) => sum + (item.cartQuantity || 1), 0)}
                  </span>
                )}
              </button>

              <button
                onClick={() => {
                  handleGoToWishlist();
                  setMobileSideMenuOpen(false);
                }}
                className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg mb-1 hover:bg-gray-50 transition-colors"
                style={{ color: storeTheme?.textColor || '#374151' }}
              >
                <FaHeart className="text-xl" />
                <div className="text-left flex-1">
                  <div className="font-medium text-sm">{t("NEWSLETTER.WISHLIST") || "Wishlist"}</div>
                </div>
                {wishlistCount > 0 && (
                  <span className="px-2 py-0.5 rounded-full text-xs font-bold text-white bg-red-500">
                    {wishlistCount}
                  </span>
                )}
              </button>

              <button
                onClick={() => {
                  handleViewOrders();
                  setMobileSideMenuOpen(false);
                }}
                className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg mb-1 hover:bg-gray-50 transition-colors"
                style={{ color: storeTheme?.textColor || '#374151' }}
              >
                <MdHistory className="text-xl" />
                <div className="text-left">
                  <div className="font-medium text-sm">{t("ONLINE_STORE.ORDER_HISTORY") || "Order History"}</div>
                  <div className="text-xs opacity-70">{t("NEWSLETTER.VIEW_PAST_ORDERS") || "View past orders"}</div>
                </div>
              </button>
            </div>

            {/* Account Section */}
            <div className="px-2">
              <p 
                className="px-3 py-2 text-xs font-semibold uppercase tracking-wider"
                style={{ color: storeTheme?.primaryColor || '#4f46e5' }}
              >
                {t("NEWSLETTER.ACCOUNT") || "Account"}
              </p>
              
              {userProfile ? (
                <>
                  <button
                    onClick={() => {
                      handleViewProfile();
                      setMobileSideMenuOpen(false);
                    }}
                    className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg mb-1 hover:bg-gray-50 transition-colors"
                    style={{ color: storeTheme?.textColor || '#374151' }}
                  >
                    <MdAccountCircle className="text-xl" />
                    <div className="text-left">
                      <div className="font-medium text-sm">{userProfile.name || "Profile"}</div>
                      <div className="text-xs opacity-70">{userProfile.customer_mobile || "View profile"}</div>
                    </div>
                  </button>
                  
                  <button
                    onClick={() => {
                      handleLogout();
                      setMobileSideMenuOpen(false);
                    }}
                    className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg mb-1 hover:bg-gray-50 transition-colors"
                    style={{ color: '#ef4444' }}
                  >
                    <MdExitToApp className="text-xl" />
                    <div className="text-left">
                      <div className="font-medium text-sm">{t("ONLINE_STORE.LOGOUT") || "Logout"}</div>
                      <div className="text-xs opacity-70">{t("NEWSLETTER.SIGN_OUT") || "Sign out of your account"}</div>
                    </div>
                  </button>
                </>
              ) : (
                <button
                  onClick={() => {
                    handleOpenLogin();
                    setMobileSideMenuOpen(false);
                  }}
                  className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg mb-1 hover:bg-gray-50 transition-colors"
                  style={{ color: storeTheme?.primaryColor || '#4f46e5' }}
                >
                  <MdLogin className="text-xl" />
                  <div className="text-left">
                    <div className="font-medium text-sm">{t("ONLINE_STORE.SIGN_IN") || "Sign In"}</div>
                    <div className="text-xs opacity-70">{t("NEWSLETTER.ACCESS_YOUR_ACCOUNT") || "Access your account"}</div>
                  </div>
                </button>
              )}
            </div>
          </div>

          {/* Menu Footer */}
          <div 
            className="p-4 border-t"
            style={{ borderColor: isDarkTheme(storeTheme) ? '#374151' : '#e5e7eb' }}
          >
            <LanguageChangerStoreFront displayType="dropdown" />
          </div>
        </div>
      </div>
    </>
  );

  // Mobile Bottom Navigation Bar
  const MobileBottomNav = () => (
    <div 
      className="fixed bottom-0 left-0 right-0 z-40 lg:hidden"
      style={{ 
        backgroundColor: storeTheme?.backgroundColor || '#ffffff',
        borderTop: `1px solid ${isDarkTheme(storeTheme) ? '#374151' : '#e5e7eb'}`,
        paddingBottom: 'env(safe-area-inset-bottom)'
      }}
    >
      <div className="flex items-center justify-around py-2 px-1">
        <button
          onClick={() => setMobileSideMenuOpen(true)}
          className="flex flex-col items-center gap-0.5 min-w-[48px]"
          style={{ color: '#6b7280' }}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
          <span className="text-[10px] font-medium">
            {t("NEWSLETTER.MENU") || "Menu"}
          </span>
        </button>
        
        <button
          onClick={() => setFilterPanelOpen(true)}
          className="flex flex-col items-center gap-0.5 min-w-[48px]"
          style={{ color: '#6b7280' }}
        >
          <MdFilterList className="text-xl" />
          <span className="text-[10px] font-medium">
            {t("STORE.FILTERS") || "Filter"}
          </span>
        </button>
        
        <button
          onClick={handleOpenCart}
          className="flex flex-col items-center gap-0.5 min-w-[48px] relative"
          style={{ color: '#6b7280' }}
        >
          <MdShoppingCart className="text-xl" />
          <span className="text-[10px] font-medium">
            {t("STORE.CART") || "Cart"}
          </span>
          {cart.length > 0 && (
            <span 
              className="absolute -top-1 right-1 text-white text-[9px] font-bold rounded-full w-4 h-4 flex items-center justify-center"
              style={{ backgroundColor: storeTheme?.primaryColor || '#4f46e5' }}
            >
              {cart.reduce((sum, item) => sum + (item.cartQuantity || 1), 0)}
            </span>
          )}
        </button>
        
        <button
          onClick={handleGoToWishlist}
          className="flex flex-col items-center gap-0.5 min-w-[48px] relative"
          style={{ color: '#6b7280' }}
        >
          <FaHeart className="text-xl" />
          <span className="text-[10px] font-medium">
            {t("NEWSLETTER.WISHLIST") || "Wishlist"}
          </span>
          {wishlistCount > 0 && (
            <span className="absolute -top-1 right-1 bg-red-500 text-white text-[9px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
              {wishlistCount}
            </span>
          )}
        </button>
        
        <button
          onClick={handleViewProfile}
          className="flex flex-col items-center gap-0.5 min-w-[48px]"
          style={{ color: '#6b7280' }}
        >
          <MdAccountCircle className="text-xl" />
          <span className="text-[10px] font-medium">
            {t("NEWSLETTER.PROFILE") || "Profile"}
          </span>
        </button>
      </div>
    </div>
  );

  if (loading) {
    return <LogoLoading />;
  }

  if (error)
    return (
      <div className='text-red-500 text-sm sm:text-base px-4'>
        {t("STORE.ERROR_COLON")} {error}
      </div>
    );
  if (!storeInfo) return <div className="px-4 text-sm">{t("STORE.NO_STORE_FOUND")}</div>;

  const userMenuElement = (
    <div className='flex items-center gap-1.5 sm:gap-2 min-w-0'>
      <UserProfileMenu
        userProfile={userProfile}
        onLogout={handleLogout}
        onViewOrders={handleViewOrders}
        onViewProfile={handleViewProfile}
        onLogin={handleOpenLogin}
        onBackToLanding={handleBackToLanding}
        theme={storeTheme}
      />
    </div>
  );

  const translateOrFallback = (key, fallback) => {
    const value = t(key);
    return !value || value === key ? fallback : value;
  };

  // Prepare layout props including Call & WhatsApp settings for the footer
  const layoutProps = {
    t,
    storeInfo,
    storeTheme,
    storeBanner,
    allProducts,
    filteredProducts,
    allServices,
    filteredServices,
    storeDescription,
    cart,
    userProfile,
    activeTab,
    setActiveTab,
    searchQuery,
    setSearchQuery,
    showOverview,
    setShowOverview,
    filterPanelOpen,
    setFilterPanelOpen,
    mobileMenuOpen: mobileSideMenuOpen,
    setMobileMenuOpen: setMobileSideMenuOpen,
    bussinessUuid,
    displayBusinessName,
    resolvedThemeId,
    storefrontPreset,
    shouldUseStoreBanner,
    getBannerUrl,
    getThemePreviewImage,
    heroVariant,
    resolvedProductVariant,
    themeStyles,
    headingStyle,
    buttonStyle,
    handleAddToCart,
    handleOpenCart,
    handleViewOrders,
    handleViewProfile,
    handleOpenLogin,
    handleLogout,
    handleBackToLanding,
    handleGoToWishlist,
    handleFilter: setFilteredProducts,
    wishlistCount,
    wishlistLoading,
    overviewContent,
    // NEW: Call & WhatsApp Settings for footer
    showCallButton,
    showWhatsappButton,
    callPhoneNumber,
    whatsappNumber,
    whatsappMessage,
    storefrontText: {
      back: translateOrFallback("BACK", "Back"),
      products: translateOrFallback("ONLINE_STORE.PRODUCTS", "Products"),
      services: translateOrFallback("ONLINE_STORE.SERVICES", "Services"),
      about: translateOrFallback("ONLINE_STORE.ABOUT_US", "About Us"),
      storeInfo: translateOrFallback("STORE.STORE_INFO", "Store Info"),
      searchProducts: translateOrFallback("NEWSLETTER.SEARCH_PRODUCTS", "Search products"),
      cart: translateOrFallback("STORE.CART", "Cart"),
      filter: translateOrFallback("NEWSLETTER.FILTERS", "Filters"),
      wishlist: translateOrFallback("NEWSLETTER.WISHLIST", "Wishlist"),
      showMore: translateOrFallback("ONLINE_STORE.SHOW_MORE", "Show More"),
      showLess: translateOrFallback("ONLINE_STORE.SHOW_LESS", "Show Less"),
      contact: translateOrFallback("ONLINE_STORE.CONTACT_INFORMATION", "Contact"),
      business: translateOrFallback("ONLINE_STORE.BUSINESS_DETAILS", "Business"),
      businessType: translateOrFallback("ONLINE_STORE.BUSINESS_TYPE", "Business Type"),
      notProvided: translateOrFallback("ONLINE_STORE.NOT_PROVIDED", "Not provided"),
      callNow: translateOrFallback("ONLINE_STORE.CALL_NOW", "Call Now"),
      whatsapp: translateOrFallback("ONLINE_STORE.WATSAPP", "WhatsApp"),
      clearSearch: translateOrFallback("STORE.CLEAR_SEARCH", "Clear Search"),
      noProductsMatch: translateOrFallback("STORE.NO_PRODUCTS_MATCH_SEARCH", "No products match your search"),
      noProductsAvailable: translateOrFallback("ONLINE_STORE.NO_PRODUCT_AVAILABLE", "No products available yet"),
      noServicesMatch: translateOrFallback("STORE.NO_SERVICES_MATCH_SEARCH", "No services match your search"),
      noServicesAvailable: translateOrFallback("ONLINE_STORE.NO_SERVICES_AVAILABLE", "No services available yet"),
      shop: translateOrFallback("ONLINE_STORE.PRODUCTS", "Shop"),
      menu: translateOrFallback("ONLINE_STORE.PRODUCTS", "Menu"),
      shopNow: translateOrFallback("SETTINGS.THEME_STORE.SHOP_NOW", "Shop Now"),
      learnMore: translateOrFallback("SETTINGS.THEME_STORE.ABOUT", "Learn More"),
      viewAll: translateOrFallback("STORE.VIEW_ALL", "View all"),
      featuredCollection: translateOrFallback("STORE.FEATURED_COLLECTION", "Featured Collection"),
      exploreAllProducts: translateOrFallback("STORE.EXPLORE_ALL_PRODUCTS", "Explore All Products"),
    },
    userMenuElement,
    removeToast,
    toasts,
  };

  return (
    <>
      {/* Toast Notifications */}
      {toasts.map((toastItem) => (
        <Toast
          key={toastItem.id}
          message={toastItem.message}
          type={toastItem.type}
          onClose={() => removeToast(toastItem.id)}
        />
      ))}

      {/* Mobile Side Menu */}
      <MobileSideMenu />

      <div className="min-h-screen pb-10 lg:pb-0">
        <ThemeLayoutContent
          layoutType={isCustomStorefrontTheme ? "clean" : getLayoutType(resolvedThemeId)}
          layoutProps={layoutProps}
        />
      </div>

      {/* Mobile Bottom Navigation */}
      <MobileBottomNav />

      {/* Filter overlay */}
      <FilterPanel
        isOpen={filterPanelOpen}
        onClose={() => setFilterPanelOpen(false)}
        allProducts={allProducts}
        onFilter={setFilteredProducts}
        theme={storeTheme}
      />

      {/* Auto-open login on first visit */}
      {autoOpenAccountDialog && (
        <AccountLoginDialog
          open={true}
          onClose={() => {
            setAutoOpenAccountDialog(false);
            handleGuestMode();
          }}
          onLogin={handleAccountLogin}
          onGuestMode={handleGuestMode}
          theme={storeTheme}
        />
      )}

      {/* Manual login trigger */}
      {accountDialogOpen && (
        <AccountLoginDialog
          open={true}
          onClose={() => setAccountDialogOpen(false)}
          onLogin={handleAccountLogin}
          onGuestMode={handleGuestMode}
          theme={storeTheme}
        />
      )}
    </>
  );
}